import React from "react";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import ReleaseVersion from "components/footer/ReleaseVersion";

export default function FixedPlugin(props) {
  const { ...rest } = props;
  const [darkmode, setDarkmode] = React.useState(
    document.body.classList.contains("dark")
  );

  return (
    <div className="flex fixed bottom-[20px] lg:bottom-[30px] !z-[99] right-[35px]">
      <div className="pr-[45px] pt-1">
        <ReleaseVersion/>
      </div>
      <button
        className="hidden ml-2 border-px flex fixed h-[30px] w-[30px] right-[35px] items-center justify-center rounded-full border-[#6a53ff] bg-gradient-to-br from-brandSecondary to-brandLinear"
        onClick={() => {
          if (darkmode) {
            document.body.classList.remove("dark");
            setDarkmode(false);
          } else {
            document.body.classList.add("dark");
            setDarkmode(true);
          }
        }}
        {...rest}
      >
        <div className="cursor-pointer text-gray-600">
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-white" />
          )}
        </div>
      </button>
    </div>
  );
}
